import {Link} from 'react-router'
import styles from './style.css'
import {shouldShowSalesTypeReports} from 'utils/ftue'

class SidebarReports extends React.Component {
  render () {
    let path = this.props.location.pathname
    let statusLabelNew = Cookies.get('labelNew') === undefined || Cookies.get('labelNew') === 'true'
    let statusLabelNewST = shouldShowSalesTypeReports()
    return (
      <div className={'col-xs-12 col-sm-12 ' + styles['slideMenu'] + ' ' + this.props.elementClass} id='sideMenu'>
        <div className={styles.hide}>
          <div className='mk-sidebar-box'>
            <ul className={`mk-side-nav ${styles['side-list']}`}>
              <li className='head visible-sm visible-xs text-bold' onClick={this.props.onToggle}>Side Menu
                <i className='fa fa-close pull-right' id='close-menu' />
              </li>
              <li className={path.startsWith('/reports/sales/summary') || path === '/reports' ? 'active' : ''}>
                <Link to='/reports/sales/summary'>Sales Summary</Link>
              </li>
              <li className={path.startsWith('/reports/sales/gross_profit') ? 'active' : ''}>
                <Link to='/reports/sales/gross_profit'>Gross Profit { statusLabelNew && <span className={styles.box_center}>NEW</span> }</Link>
              </li>
              <li className={path.startsWith('/reports/sales/payment_methods') ? 'active' : ''}>
                <Link to='/reports/sales/payment_methods'>Payment Methods</Link>
              </li>
              <li className={path.startsWith('/reports/sales/sales_type') || path === '/reports' ? 'active' : ''}>
                <Link to='/reports/sales/sales_type'>Sales Type { statusLabelNewST && <span className={styles.box_center}>NEW</span> }</Link>
              </li>
              <li className={path.startsWith('/reports/sales/item_sales') ? 'active' : ''}>
                <Link to='/reports/sales/item_sales'>Item Sales</Link>
              </li>
              <li className={path.startsWith('/reports/sales/category_sales') ? 'active' : ''}>
                <Link to='/reports/sales/category_sales'>Category Sales</Link>
              </li>
              <li className={path.startsWith('/reports/sales/modifier_sales') ? 'active' : ''}>
                <Link to='/reports/sales/modifier_sales'>Modifier Sales</Link>
              </li>
              <li className={path.startsWith('/reports/sales/discounts') ? 'active' : ''}>
                <Link to='/reports/sales/discounts'>Discounts</Link>
              </li>
              <li className={path.startsWith('/reports/sales/taxes') ? 'active' : ''}>
                <Link to='/reports/sales/taxes'>Taxes</Link>
              </li>
              <li className={path.startsWith('/reports/sales/gratuity') ? 'active' : ''}>
                <Link to='/reports/sales/gratuity'>Gratuity</Link>
              </li>
              <li className={path.startsWith('/reports/sales/staff') ? 'active' : ''}>
                <Link to='/reports/sales/staff'>Collected By</Link>
              </li>
              <li className={path.startsWith('/reports/sales/server') ? 'active' : ''}>
                <Link to='/reports/sales/server'>Served By</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    )
  }
}

export default SidebarReports



// WEBPACK FOOTER //
// ./app/components/SidebarReports/SidebarReports.js